module.exports = __webpack_public_path__ + "img/微波.106b0220.png";